<ion-button [expand]="this.expand" [color]="this.color" [disabled]="this.disabled" [type]="this.buttonType">
  <span>
    <ng-content *ngIf="this.sending !== true"></ng-content>
    <ion-spinner *ngIf="this.sending === true"></ion-spinner>
  </span>
</ion-button>
